<template>
  <v-flex mx-auto class="mb-4">
    <v-select
    persistent-hint
    hint="Select The Date For This Entry"
    class="px-3"
    :items="dates"
    single-line color="grey"
    @change="updateCurrentDate($event)"
    v-model="select" item-value="text"
  ></v-select>
  <!-- {{select}} -->
  </v-flex>
</template>

<script>

import {roundDate} from './date-utils.js'


var curDate=new Date(parseInt(localStorage.currentDate));

var today = roundDate(new Date(new Date().setDate(new Date().getDate())));
var yesterday = roundDate(new Date(new Date().setDate(new Date().getDate() - 1)));
var twoDaysAgo = roundDate(new Date(new Date().setDate(new Date().getDate() - 2)));
var selectedDateValue="";
var selectedDate;

//assign rounded timestamps to keys in array
var dateOptions=[];
dateOptions['Today']=today;
dateOptions['Yesterday']=yesterday;
dateOptions['2 Days Ago']=twoDaysAgo;
var selectDates=[
          { text: 'Today' },
          { text: 'Yesterday' },
          { text: '2 Days Ago' },
 ];

function findDate(){

  //Find current localStroage date value, or set default
  curDate=new Date(parseInt(localStorage.currentDate));
  for (var key in dateOptions){

    if (dateOptions.hasOwnProperty(key)) {
        if(dateOptions[key]==curDate.getTime()){
          selectedDateValue=key;
        }
    }
  }


      selectedDate=new Date(dateOptions[selectedDateValue]);
      localStorage.currentDate=selectedDate.getTime();

  //set default to today, if no corresponding date is found
  if(selectedDateValue==""){
    //set back to today
    selectedDateValue="Today";
    selectedDate=new Date(dateOptions['Today']);
    localStorage.currentDate=selectedDate.getTime();
  }
}
findDate();

export default {
  data () {
    return {
      dates: selectDates,
      selectedDate: selectedDateValue,
      select: selectedDateValue,
    }
  },
  methods: {
    goBack(){ this.$router.back(); },
    updateCurrentDate(selectedItem){
      //updated selectedDateValue, update
      selectedDateValue=selectedItem;
      selectedDate=new Date(dateOptions[selectedItem]);
      localStorage.currentDate=selectedDate.getTime();
      //we need to update all daily local values
      this.$root.$emit('DateChange', localStorage.currentDate);

    }
  },
  created(){

    findDate();
  },
  mounted(){
     findDate();
  },
}
</script>



// WEBPACK FOOTER //
// src/components/DateSelect.vue